import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';

import { postAngularNavigation } from '../communication/shell-requests';
import { ExposedRoute } from '../navigation-manifest';
import { ENABLE_STANDALONE_NAVIGATION } from './standalone-navigation';

@Service()
export class ShellNavigation {
  private readonly directNavigationEnabled =
    inject(ENABLE_STANDALONE_NAVIGATION, {
      optional: true,
    }) ?? false;

  private readonly router = inject(Router);

  async navigate(route: ExposedRoute): Promise<void> {
    try {
      // Always notify the Shell when one is present.
      postAngularNavigation(route);
      // In standalone mode there is no Shell to process the message,
      // so navigate using Angular's browser-backed router.
      if (!this.directNavigationEnabled) {
        return;
      }

      const hasNavigated = await this.router.navigateByUrl(route);
      if (!hasNavigated) {
        console.warn(`[ShellNavigation] Navigation to "${route}" was not completed.`);
      }
    } catch (error: unknown) {
      console.error(`[ShellNavigation] Navigation to "${route}" failed:`, error);
    }
  }
}
